module.exports = __webpack_public_path__ + "img/open.1f3cd3a1.svg";